// Cache entre pestañas del resultado de fetchCurrent()+getAdminPermissions() (WDUR-tabs-lentas):
// con muchas pestañas abriendo casi al mismo tiempo, cada una repetía estas 2 requests sin ninguna
// coordinación, compitiendo por el límite de conexiones concurrentes del navegador contra el mismo
// origen (8 pestañas -> hasta 16 requests simultáneas). El resultado es IDÉNTICO para todas las
// pestañas del mismo usuario/token (mismo access_token compartido vía LocalStorage), así que es
// seguro compartirlo un rato corto. TTL de 10s: solo absorbe el caso "muchas pestañas casi
// simultáneas" -- no es una cache de sesión larga. AdminIndex.vue sigue llamando fetchCurrent() a
// secas (sin pasar por esta cache) para su propio caso de uso de datos frescos on-demand.
//
// localStorage NATIVO (no el de Quasar), mismo criterio que offline/flags.js: se lee/escribe
// síncrono entre pestañas sin depender de la codificación propia de Quasar.
const BOOT_CACHE_KEY = 'boot_current_user_cache'
const BOOT_CACHE_TTL_MS = 10000

// Nombre del Web Lock que coordina el fetch real entre pestañas (mismo primitivo que ya usa
// offline/sync/sync-worker.js para el leader election del tick, y selectBackend.js para el backend
// OPFS exclusivo). A diferencia de esos dos usos, aquí NO se pide con `ifAvailable`: las pestañas
// que no ganan la carrera se QUEDAN EN COLA esperando su turno (no se saltan el trabajo), porque
// cuando les toque van a encontrar la cache ya escrita por quien las precedió y van a resolver casi
// gratis -- ese encadenamiento es lo que evita que 8 pestañas disparen 16 requests a la vez.
export const BOOT_FETCH_LOCK_NAME = 'boot-fetch-current'

/** Entrada vigente de la cache, o null si no existe/venció/está corrupta/tiene ts futuro. */
export function readBootCurrentCache () {
  try {
    const raw = typeof localStorage !== 'undefined' ? localStorage.getItem(BOOT_CACHE_KEY) : null
    if (!raw) return null
    const entry = JSON.parse(raw)
    if (!entry || typeof entry.ts !== 'number') return null
    const age = Date.now() - entry.ts
    if (age < 0 || age > BOOT_CACHE_TTL_MS) return null
    if (!entry.user || !Array.isArray(entry.permissions)) return null
    return entry
  } catch {
    return null
  }
}

/** Escribe la cache tras un fetch real exitoso. Best-effort: nunca debe romper el boot. */
export function writeBootCurrentCache (user, permissions) {
  try {
    localStorage.setItem(BOOT_CACHE_KEY, JSON.stringify({ user, permissions, ts: Date.now() }))
  } catch {
    // Sin localStorage (privado/cuota llena) o dato no serializable: no-op. La coordinación
    // simplemente no aplica para esta pestaña -- no es motivo para romper el boot.
  }
}

/**
 * Invalida la cache. Debe llamarse en login()/logout() (auth/actions.js): sin esto, en un device
 * COMPARTIDO, una pestaña nueva abierta justo tras un cambio de sesión podría hidratar el usuario
 * VIEJO desde la cache dentro de la ventana de 10s -- exposición cross-usuario/cross-org, la misma
 * clase de riesgo que ya cuida wipeCatalogsForUserChange() para los catálogos offline.
 */
export function clearBootCurrentCache () {
  try { localStorage.removeItem(BOOT_CACHE_KEY) } catch { /* no-op */ }
}
